import React from 'react';
import { ComponentType } from 'react';
import { connect } from 'react-redux';
import { Action, ActionFunction2 } from 'redux-actions';
import { createStructuredSelector } from 'reselect';
import { Coin } from 'store/Coin/types';
import { fetch as fetchChart } from 'store/Market/Chart/actions';
import { getChartDataForCoin } from 'store/Market/Chart/selectors';
import { ChartDataPoint } from 'store/Market/Chart/types';

interface PassedProps {
  coin: Coin;
}

interface MappedStateToProps {
  chartData: ChartDataPoint[];
}

interface MappedDispatchToProps {
  fetchChart: ActionFunction2<
    string,
    string,
    Action<{ coinId: string; period: string }>
  >;
}

type InjectedProps = MappedStateToProps & MappedDispatchToProps;

const withContainer = <Props extends PassedProps>(
  WrappedComponent: ComponentType<Props & InjectedProps>,
) => {
  const WithContainer = (props: Props & InjectedProps) => (
    <WrappedComponent {...props} />
  );

  const mapStateToProps = (state: any, props: Props) => {
    const getChartData = getChartDataForCoin(props.coin.id);

    return createStructuredSelector({
      chartData: getChartData,
    })(state);
  };

  const mapDispatchToProps = {
    fetchChart,
  };

  // related bug: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31363
  return connect<MappedStateToProps, MappedDispatchToProps, Props>(
    mapStateToProps,
    mapDispatchToProps,
  )(WithContainer as any);
};

export default withContainer;
